import { hasShareholderPagePermission } from '../authStorage';
import { useT } from '../i18n/translations';

export default function ShareholderPagePermissionGuard({ moduleId, children }) {
  const t = useT();
  if (!hasShareholderPagePermission(moduleId)) {
    return (
      <div style={{ padding: 28, fontFamily: 'Cairo, sans-serif', color: '#78909c' }}>
        {t('common.noPerm')}
      </div>
    );
  }
  return children;
}
